import { useTranslation } from 'react-i18next'

import { useGeneralErrors } from '@/hooks/useGeneralErrors'

export const GeneralErrorsBanner = () => {
  const { t } = useTranslation()
  const { generalErrors } = useGeneralErrors()

  if (!generalErrors) return null

  return (
    <div className="animate-fade-in bg-gray-background flex flex-col gap-2 p-6" data-testid="general-errors-banner">
      {generalErrors.map((error, index) => (
        <span key={index} className="text-error font-bold">
          {t(error.message)}
        </span>
      ))}
    </div>
  )
}
